import * as React from "react"
import { StoreProvider } from "./src/context/store-context"
import { CookiesProvider } from "react-cookie"
import "./src/styles/reset.css"
import "./src/styles/variables.css"
import "./src/styles/global.css"
import "react-responsive-carousel/lib/styles/carousel.min.css" // requires a loader
import "react-image-lightbox/style.css" // This only needs to be imported once in your app
import "@fontsource/montserrat" // Defaults to weight 400 with normal variant.

// Gatsby's default Link prefetches page-data.json for every link that scrolls into
// view, which was silently downloading data for pages visitors never navigated to
// (bulk of our Firebase Hosting bandwidth). Disable it.
export const disableCorePrefetching = () => true

export const wrapRootElement = ({ element }) => (
  <CookiesProvider defaultSetOptions={{ path: "/" }}>
    <StoreProvider>{element}</StoreProvider>
  </CookiesProvider>
)
